import { useEffect, useMemo } from "react";
import MxAutoCompleteField from "./MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "./MxAutoCompleteField/model/MxAutoCompleteField";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { useLazyGetImprovementsQuery } from "@/src-refactor/modules/store/qrtk/services/generics";

type omit = "items";
type MxSelectImprovementsFieldProp = Omit<MxAutoCompleteFieldProps, omit>;
const MxSelectImprovementsField = (props: MxSelectImprovementsFieldProp) => {
  const [getImprovements, { data, isLoading, isUninitialized, isError }] =
    useLazyGetImprovementsQuery();

  const Items = useMemo(() => {
    if (!Array.isArray(data?.data)) return [];
    if (isLoading || isUninitialized || isError) return [];
    if (data?.data?.length == 0) return [];
    return data?.data?.map(item => ({
      id: item.id,
      label: item.name,
      value: item.id,
      name: item.name
    })) as I_GENERIC_ITEMS[];
  }, [data, isLoading, isUninitialized, isError]);

  useEffect(() => {
    getImprovements({
      query: {}
    });
  }, []);

  const onSearch = (value: string) => {
    getImprovements({
      query: {
        q: value
      }
    });
  };

  return (
    <MxAutoCompleteField
      {...props}
      onSearch={onSearch}
      items={Items}
      loading={isLoading}
    />
  );
};

export default MxSelectImprovementsField;
